import { useContext } from 'react';

import { ClientFiltersContext } from '@app/providers';

import {
  getDataBeforeTargetKey,
  clearPeriod,
} from '@pages/Clients/ClientsList/utils';

import { ClientFilterTag } from '@pages/Clients/ClientsList/components/Filters/ClientFilterTag';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const DatesTagContainer: NClientsList.DatesTagContainer = ({
  filtersArea,
  filterGroupIndex,
  label,
  valueKey,
}) => {
  const { filters, serverFilters, setFilters, setServerFilters } =
    useContext(ClientFiltersContext);

  const additionalCondition =
    !!getDataBeforeTargetKey({
      oldFilters: serverFilters,
      filtersArea,
      filterGroupIndex,
    })?.[0]?.DateStart ||
    !!getDataBeforeTargetKey({
      oldFilters: serverFilters,
      filtersArea,
      filterGroupIndex,
    })?.[0]?.DateEnd;

  return (
    <ClientFilterTag
      filters={filters}
      serverFilters={serverFilters}
      filtersArea={filtersArea}
      filterGroupIndex={filterGroupIndex}
      isPeriodFilter={true}
      valueKey={valueKey}
      setFilters={setFilters}
      setServerFilters={setServerFilters}
      handleTagDeletion={() => {
        clearPeriod({
          filters,
          serverFilters,
          filtersArea,
          filterGroupIndex,
          setFilters,
          setServerFilters,
        });
      }}
      additionalCondition={additionalCondition}
    >
      {label || 'Без названия'}
    </ClientFilterTag>
  );
};
